import { render, staticRenderFns } from "./fundPolicyAllocation.vue?vue&type=template&id=567e7e2b&scoped=true&"
import script from "./fundPolicyAllocation.vue?vue&type=script&lang=js&"
export * from "./fundPolicyAllocation.vue?vue&type=script&lang=js&"
import style0 from "./fundPolicyAllocation.vue?vue&type=style&index=0&id=567e7e2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e7e2b",
  null
  
)

export default component.exports